import * as React from 'react'
import clsx from 'clsx'
import { Select as MUISelect, MenuItem, SelectProps } from '@mui/material'

import styles from './Select.module.scss'

export interface SelectOption {
  label: React.ReactNode
  value: string | number
}

export type SelectWrapperProps = SelectProps & {
  options: SelectOption[]
  fullWidth?: boolean
  wrapperClassName?: string
  wrapperStyle?: React.CSSProperties
}

const Select = ({
  options,
  children,
  fullWidth = false,
  wrapperClassName,
  wrapperStyle,
  sx,
  ...selectProps
}: SelectWrapperProps) => {
  return (
    <div
      className={clsx(
        styles.inputRoot,
        { [styles.fullWidth]: fullWidth },
        wrapperClassName
      )}
      style={wrapperStyle}
    >
      <MUISelect
        {...selectProps}
        variant="outlined"
        fullWidth={fullWidth}
        className={styles.input}
        notched={false}
        sx={{
          backgroundColor: '#fff',
          borderRadius: 0,

          '& .MuiSelect-select': {
            padding: '10px 12px',
            fontSize: '16px',
            color: '#222',
            lineHeight: '1.5',
          },

          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
            borderRadius: 0,
          },

          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#999',
          },

          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#666',
          },

          '& .MuiSelect-icon': {
            color: '#222',
          },

          ...sx,
        }}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            sx={{
              fontSize: '16px',
              padding: '8px 12px',
            }}
          >
            {option.label}
          </MenuItem>
        ))}
        {children}
      </MUISelect>
    </div>
  )
}

export default Select
